<div class="login h-100vh" style="overflow: auto">
  <button class="btn btn-primary" (click)="scrollToTopFunction()" id="scrollToTpBtn" title="Go to top">
    <i class="fas fa-caret-up fa-2x"></i>
  </button>
  <header class="pt-0 pb-0">
    <nav class="">
      <div class="align_left">
        <img class="logo" src="./assets/images/stag_logo.png" alt="logo">
      </div>
      <div>
      </div>
      <div class="align_right">
        <!-- <button class="btn btn-downloadprimary" (click)="printWindow()">{{ 'cockpitReport.print' | translate }}</button> -->
      </div>
    </nav>
  </header>

  <div class="row strict h-100">
    <div class="well mb-0 h-100">
      <div class="row strict">
        <h3>[Jira Project Name: {{project.jiraProjectDetails.name}}]</h3>
      </div>

      <div class="row h-100">
        <div class="col-6 col-xs-6 pr-3 h-100">
          <div class="alert alert-warning" *ngIf="!jiraStoriesList.length">
            <strong>
              No stories available in Jira project.
            </strong>
          </div>
          <div class="row pl-0 pr-0" *ngIf="jiraStoriesList.length">
            <div class="col-xs-12">
              <div class="input-group input-group-sm">
                <input type="text" class="form-control search-add-on" [(ngModel)]="searchText"
                  [placeholder]="'jira.searchStory' | translate " />
                <span class="input-group-addon " id="basic-addon2">
                  <fa-icon class="fas icon-black" [icon]="faSearch"></fa-icon>
                </span>
              </div>
            </div>
          </div>
          <div class="" *ngFor="let bug of jiraStoriesList|jiraSearch:searchText; let tabIndex = index">
            <div class="p-1 border" (click)="loadJiraStoryDetails(bug)">
              ({{bug.id}}) {{ bug.fields.summary }}
            </div>
            <hr class="m-1"/>
          </div>
          <div class="row pt-0 pm-0">
            <div class="col-6 col-xs-6">
              <nav>
                <ul class="pagination floatleft">
                  <!-- [ngClass]="{ dis: skipNotifyCount<=0 }" -->
                  <li class="page-item">
                    <a class="page-link" tabindex="-1" (click)="getAllNotifications('prev','')">
                      <<{{ 'jira.prev' | translate }}</a>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="col-6 col-xs-6">
              <nav>
                <ul class="pagination floatright">
                  <!-- [ngClass]="{ dis: skipNotifyCount+10 >= maxNotifyCount }" -->
                  <li class="page-item">
                    <a class="page-link" (click)="getAllNotifications('next','')">
                      {{ 'jira.next' | translate }}>>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div class="col-6 col-xs-6 pl-3 h-100">
          <div class="h-100" id="jiraBugArrayList"></div>
        </div>
      </div>
    </div>
  </div>
  <footer>
    <p class="copyright">
      {{ 'cockpitReport.generatedBy' | translate }} {{userName}} {{ 'cockpitReport.on' | translate }}
    </p>
  </footer>
</div>